import { render, staticRenderFns } from "./ActiveGrantFilter.vue?vue&type=template&id=f8d36e52&scoped=true&"
import script from "./ActiveGrantFilter.vue?vue&type=script&lang=js&"
export * from "./ActiveGrantFilter.vue?vue&type=script&lang=js&"
import style0 from "./ActiveGrantFilter.vue?vue&type=style&index=0&id=f8d36e52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8d36e52",
  null
  
)

export default component.exports